import React from "react";
import Button from '@mui/material/Button';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Man2Icon from '@mui/icons-material/Man2';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import StayPrimaryPortraitIcon from '@mui/icons-material/StayPrimaryPortrait';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useAddUserHook from "./addUserHook";
import convert from "../../../Helper/helper";
import "./addUser.scss";

const initialState = {
    userName: "",
    password: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
    emailID: "",
    dateOfBirth: convert(new Date()),
    userGroup: ""
}
const AddUser = () => {
    const { userState, handleInputChange, handleSubmit, allowNumbersOnly, handleBlur, 
        errors: { errors } , handleGoBack} = useAddUserHook(initialState)
    return (
        <>
            <form className="needs-validation" novalidate>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>User Information</h4>
                        <div className="back-btn"
                        >
                            <ArrowBackIcon className="arrow-color"
                            
                            />
                            <span
                                onClick={handleGoBack}
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="validationCustom03" className="control-label col-sm">User Name*</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <input type="text"
                                        onBlur={handleBlur}
                                        className={
                                            errors?.userName ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="userName"
                                        required
                                        placeholder="User Name" name="userName"
                                        value={(userState?.userName?.toUpperCase())}
                                        onChange={handleInputChange}
                                        aria-describedby="validationTooltipUsernamePrepend"
                                    />
                                    <div class="invalid-feedback">
                                        Please provide a valid User Name.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Password*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><CalendarMonthIcon /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="password"
                                        className={
                                            errors?.password ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        placeholder="Password"
                                        name='password'
                                        onChange={handleInputChange}
                                        value={userState?.password}
                                        required
                                    />
                                    <div class="invalid-feedback">
                                        Please provide a valid Password.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">First Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={errors?.firstName ?
                                            "form-control is-invalid" : "form-control"}
                                        id="lname" placeholder="First Name"
                                        name="firstName"
                                        onChange={handleInputChange}
                                        value={userState?.firstName}

                                    />
                                    <div class="invalid-feedback">
                                    {errors?.firstName ? "Please Enter Valid First Name": ""}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Last Name</label>
                            <div cmobilelass="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control"
                                        id="lastName" placeholder="Last Name" name="lastName"
                                        onChange={handleInputChange}
                                        value={userState?.lastName}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">DateOf Birth</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><ContactMailIcon /></div>
                                    </div>
                                    <input
                                        type="date"
                                        className={"form-control"}
                                        id="lname" placeholder="DateOf Birth" name="dateOfBirth"
                                        onChange={handleInputChange}
                                        value={userState?.dateOfBirth}
                                        max={new Date()?.toISOString()?.split("T")[0]}
                                    />
                                   
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Mobile Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><StayPrimaryPortraitIcon /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        className={errors?.mobileNumber ?
                                            "form-control is-invalid" : "form-control"}
                                        id="lname"
                                        placeholder="Mobile Number"
                                        name="mobileNumber"
                                        onChange={handleInputChange}
                                        value={userState?.mobileNumber}
                                        required
                                        onKeyDown={(e) => allowNumbersOnly(e)}
                                        maxlength="10" />
                                    <div class="invalid-feedback">
                                        {errors?.mobileNumber ? "Please Enter a Valid Mobile Number" : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">User Group*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><Man2Icon /></div>
                                    </div>
                                    <select

                                        onBlur={handleBlur}
                                        className={errors?.userGroup ?
                                            "form-control is-invalid" : "form-control"}
                                        selected={userState?.userGroup}
                                        onChange={handleInputChange}
                                        value={userState?.userGroup}
                                        required
                                        name="userGroup"
                                    >
                                        <option></option>
                                        <option value={"admin"}>Admin</option>
                                        <option value={"accounts"}>Accounts</option>
                                        <option value={"frontoffice"}>Front office</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Please provide a valid User Group.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Email</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AlternateEmailIcon /></div>
                                    </div>
                                    <input
                                       
                                        type="email"
                                        className={"form-control"}
                                        id="fname" placeholder="Email" name="emailID"
                                        onChange={handleInputChange}
                                        value={userState?.emailID}
                                    />
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => handleSubmit(event)}
                    >
                        Add User</Button>
                </div>
            </form>
        </>
    )
}

export default AddUser;